import { render, staticRenderFns } from "./IntrabankTransfer.vue?vue&type=template&id=21c3c4d4&"
import script from "./IntrabankTransfer.vue?vue&type=script&lang=js&"
export * from "./IntrabankTransfer.vue?vue&type=script&lang=js&"
import style0 from "./IntrabankTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports